/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-10 09:32:13
 * @LastEditors: K
 * @LastEditTime: 2022-09-21 11:04:47
 */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { useContext } from 'react'
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import { commodityPageParams } from '../../../../services/commodity'
import { DateSelect as DateSelectOne, RecentTime } from '../../../../compnents/date/TimeSelect'
import { ThemeContext } from '../../../../theme/ThemeContext'

export const Query = (props: {
  onValueChange: (queries: commodityPageParams) => void
}) => {

  const theme = useContext(ThemeContext)
  const [form] = Form.useForm()

  const recipeStatusOptions = [
    {
      value: 0,
      label: '未上传',
    },
    {
      value: 1,
      label: '已上传',
    },
  ]

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs) => {
        const time = {
          pullTimeHead: null,
          pullTimeTail: null,
          createListTimeHead: fs?.pullTimeHead,
          createListTimeTail: fs?.pullTimeTail
        }
        props.onValueChange({
          ...fs,
          current: 1,
          ...time
        })
      }}
      style={{ marginTop: 20 }}
    >
      <Row
        gutter={11}
        style={{ height: '60px', justifyContent: 'space-between' }}
      >
        <Space>
          <Form.Item name='param'>
            <Input
              size='middle'
              placeholder='患者姓名'
              onChange={form.submit}
              allowClear
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name='supplierKeyWord'>
            <Input
              size='middle'
              placeholder='代煎饮片厂名称/助记码'
              onChange={form.submit}
              allowClear
            />
          </Form.Item>
          <Form.Item name='tenantkeyWord'>
            <Input
              size='middle'
              placeholder='机构名称/助记码'
              onChange={form.submit}
              allowClear
            />
          </Form.Item>

          <Form.Item>
            <DateSelectOne
              options={RecentTime}
              placeholder='开单时间'
              style={{ width: 150 }}
              labelPrefix=''
              onChange={form.submit}
              namePrefix='pullTime'
            />
          </Form.Item>
          <Form.Item name='status'>
            <Select
              allowClear
              placeholder='上传状态'
              onChange={form.submit}
              style={{ width: 150 }}
            >
              {recipeStatusOptions.map((c) => (
                <Select.Option key={c.label} value={c.value}>
                  上传状态-{c.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name='signedType' >
            <Select
              suffixIcon={
                <CaretDownFilled style={{ color: theme.tc3 }} />
              }
              placeholder='签约状态'
              onChange={form.submit}
              style={{ width: 150 }}
            >
              <Select.Option value={''}>全部</Select.Option>
              <Select.Option value={1}>已签约</Select.Option>
              <Select.Option value={0}>未签约</Select.Option>
            </Select>
          </Form.Item>
        </Space>

        <Button
          htmlType='submit'
          type='primary'
          style={{ marginRight: 30 }}
        >
          查询
        </Button>
      </Row>
    </Form>
  )
}
